import { httpPost } from "../httpService/httpService";
import { LoadingParams } from "./props/checkUploadGeometryServiceProps";

export const checkUploadGeometry = (parameters: LoadingParams, apiUrl: string) => {
    const formData = new FormData();
    formData.append('guid', parameters.guid);
    return new Promise((resolve, reject) => (
    httpPost(`${apiUrl}/check-loading`, formData)
    .then((res: any) => {
        resolve(res.data);
    })
    .catch((error: any) => {
        reject(`Błąd: ${error.message}`);
    })
    ));
}

export const cancelUploadGeometry = (apiUrl: string, guid: string) => {
    const formData = new FormData();
    formData.append('guid', guid);
    return new Promise((resolve, reject) => (
    httpPost(`${apiUrl}/cancel-loading`, formData)
    .then((res: any) => {
        resolve(res.data);
    })
    .catch((error: any) => {
        reject(`Błąd: ${error.message}`);
    })
    ));
}